import { Injectable } from '@angular/core';

@Injectable()
export class EnvService {
    apiBaseUrls:string= 'https://idapi.development.wgu.edu/v1/selfservice1'
    domain:string= 'my-account.development.wgu.edu'
    production:boolean=false
}